import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ErrorFallback from './components/ErrorFallback';
import {getChunkLoadDiagnostics, isChunkLoadError} from './utility/chunkLoadRecovery';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import BugsnagPerformance from '@bugsnag/browser-performance';

const bugsnagApiKey = process.env.REACT_APP_BUGSNAG_API_KEY || 'ef1eff6ec9c555df99cf551a5a7f7ed1';
const bugsnagAppVersion = process.env.REACT_APP_VERSION || '2.5.0';

const addChunkLoadDiagnostics = (event, error) => {
  if (!isChunkLoadError(error)) return;

  event.addMetadata('chunkLoad', getChunkLoadDiagnostics(error));
  event.context = 'chunk-load-error';
};

if (bugsnagApiKey) {
  Bugsnag.start({
    apiKey: bugsnagApiKey,
    plugins: [new BugsnagPluginReact()],
    releaseStage: process.env.NODE_ENV,
    enabledReleaseStages: ['production', 'staging'],
    appVersion: bugsnagAppVersion,
    onError: event => {
      addChunkLoadDiagnostics(event, event.originalError);
    },
  });
  BugsnagPerformance.start({apiKey: bugsnagApiKey});
}

// replace console.* for disable log on production
if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.error = () => {};
  console.debug = () => {};
}
console.log('env', process.env.NODE_ENV);

const ErrorBoundary = bugsnagApiKey ? Bugsnag.getPlugin('react').createErrorBoundary(React) : null;

const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

ReactDOM.render(
  ErrorBoundary ? (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onError={event => {
        addChunkLoadDiagnostics(event, event.originalError);

        if (isChunkLoadError(event.originalError)) {
          Bugsnag.leaveBreadcrumb('chunk-load-boundary-caught', {
            errorClass: event.errors?.[0]?.errorClass || null,
          });
        }
      }}
    >
      {app}
    </ErrorBoundary>
  ) : (
    app
  ),
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
